export default __webpack_public_path__ + "aefe14a5ad9a963f30ee846c2a1306e7.png";